<template>
  <div class="vg-picker">
    <div class="vg-picker-input">
      <van-image class="filter" width="24" height="24" :src="srcFilter" @click="onFilter"/>
    </div>
    <van-popup class="vg-picker-popup" v-model="show" position="right" :style="{ width: '70%' }">
      <div style="color: #101010; font-size: 20px; margin-top: 40px">筛选条件</div>
      <van-divider style="margin: 10px 0;" :style="{ borderColor: '#BBBBBB' }"/>
      <div style="color: #101010; font-size: 16px;">订单时间</div>
      <div class="month" :class="{monthselected: showChooseMonth}" @click="onChooseMonth">
        <input class="input" readonly :value="getDateStr" placeholder="请选择月份"/>
        <van-image width="20" height="20" :src="srcDate"/>
      </div>
      <div class="choose-month" v-if="showChooseMonth">
        <div class="choose-header">
          <div class="year">{{ year }}</div>
          <van-image width="20" height="20" :src="srcLeftArrow" @click="onYearSub"/>
          <van-image style="margin-left: 30px" width="20" height="20" :src="srcRightArrow" @click="onYearAdd"/>
        </div>
        <van-divider style="margin: 10px 0;" :style="{ borderColor: '#BBBBBB' }"/>
        <van-grid :border="false" :column-num="4">
          <van-grid-item class="month-item" v-for="value in 12" :key="value" @click="onMonth(value)">
            <div class="month-text" :class="{monthtextselected: isSelectedMonth(value)}">
              {{ value }}月
            </div>
            <div class="month-point" v-if="isSelectedMonth(value)"/>
          </van-grid-item>
        </van-grid>
      </div>
      <div style="color: #101010; font-size: 16px; margin-top: 20px">项目</div>
      <!--      <div class="project" @click="onChooseProject">-->
      <!--        <input class="input" readonly :value="currentProject" placeholder=""/>-->
      <!--        <van-image width="12" height="12" :src="srcDown"/>-->
      <!--      </div>-->
      <vg-invoice-popup-picker title="请选择项目" v-model="projectId" :columns="projects" :has-project-id="true" @input="onChooseProject"/>
      <template v-if="isSporadicCharge">
        <div style="color: #101010; font-size: 16px; margin-top: 20px">科目</div>
        <vg-invoice-popup-picker title="请选择科目" v-model="subjectId" :columns="subjects" :has-project-id="hasProjectId" @input="onChooseSubject"/>
      </template>
      <div class="btn">
        <van-button class="button-default" @click.native="onReset">重置</van-button>
        <van-button class="button-primary" @click.native="onSubmit">提交</van-button>
      </div>
    </van-popup>
  </div>

</template>

<script>
import {Button, Divider, Grid, GridItem, Image as VanImage, Popup} from "vant";
import srcFilter from "@/assets/scanverify/filter.svg";
import srcDate from "@/assets/icon-date.svg";
import srcDown from "@/assets/more.svg";
import srcRightArrow from "@/assets/arrow_right.svg";
import srcLeftArrow from "@/assets/arrow_left.svg";
import {client} from "@/libraries/http";
import VgInvoicePopupPicker from "@/components/VgInvoicePopupPicker";

export default {
  name: "VgInvoiceFilterPicker",
  components: {
    VanImage,
    "van-popup": Popup,
    "van-divider": Divider,
    "van-button": Button,
    "van-grid": Grid,
    "van-grid-item": GridItem,
    VgInvoicePopupPicker,
  },
  props: {
    originalDate: {
      type: Object,
      default() {
        return {
          year: 0,
          month: 0,
        };
      }
    },
    originalProject: {
      type: Object,
      default() {
        return {};
      }
    },
    originalSubject: {
      type: Object,
      default() {
        return {};
      }
    },
    orderType: {
      type: String,
      default: "",
    },
    orderPhoneNum: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      srcFilter: srcFilter,
      srcDate: srcDate,
      srcDown: srcDown,
      srcLeftArrow: srcLeftArrow,
      srcRightArrow: srcRightArrow,
      show: false,
      showChooseMonth: false,
      year: 2022,
      currentDate: {},
      currentProject: null,
      currentSubject: null,
      projectId: null,
      projects: [],
      subjects: [],
      subjectId: null,
      hasProjectId: false,
    }
  },
  created() {
    console.log(this.orderType, this.orderPhoneNum);
  },
  computed: {
    getDateStr() {
      if (this.currentDate.year > 0 && this.currentDate.month > 0) {
        return this.currentDate.year + "-" + (this.currentDate.month < 10 ? "0" + this.currentDate.month : this.currentDate.month);
      } else {
        return "";
      }
    },
    isSporadicCharge() {
      return this.orderType === "SPORADIC_CHARGE";
    },
  },
  methods: {
    onFilter() {
      this.show = !this.show;
      if (this.show) {
        this.currentDate = this.originalDate;
        this.currentProject = this.originalProject;
        this.getProjectList();
        if (this.isSporadicCharge) {
          this.currentSubject = this.originalSubject;
          // this.getSubjectList();
        }
      }
    },
    onChooseMonth() {
      this.showChooseMonth = !this.showChooseMonth;
      if (this.showChooseMonth) {
        if (this.currentDate.year > 0) {
          this.year = this.currentDate.year;
        } else {
          this.year = new Date().getFullYear();
        }
      }
    },
    onYearSub() {
      this.year--;
    },
    onYearAdd() {
      this.year++;
    },
    isSelectedMonth(value) {
      return this.currentDate.year === this.year && this.currentDate.month === value;
    },
    onMonth(value) {
      this.currentDate.year = this.year;
      this.currentDate.month = value;
      this.showChooseMonth = false;
    },
    onChooseProject(projectId) {
      let selected = this.projects.filter(item => item.value === projectId)[0];
      this.currentProject.projectId = selected.value;
      this.currentProject.projectName = selected.text;
      this.getSubjectList(this.currentProject.projectId);
      this.hasProjectId = true;
    },
    onChooseSubject(subjectId) {
      let selected = this.subjects.filter(item => item.value === subjectId)[0];
      this.currentSubject.id = selected.value;
      this.currentSubject.name = selected.text;
    },
    onReset() {
      this.currentDate = {year: 0, month: 0};
      this.currentProject = {};
      this.projectId = null;
      this.currentSubject = {};
      this.subjectId = null;
      this.hasProjectId = false;
    },
    onSubmit() {
      this.$emit("on-invoice-filter", this.currentDate, this.currentProject, this.currentSubject);
      this.show = false;
    },
    getProjectList() {
      client.get("/api/h5/invoice/projects" + "?phoneNum=" + this.orderPhoneNum + "&orderType=" + this.orderType
      ).then(res => {
        console.log(res);
        this.projects = res.data.map(dto => ({
          value: dto.projectId,
          text: dto.projectName,
        }));
        this.projectId = this.currentProject?.projectId;
      })
    },
    getSubjectList(projectId) {
      client.get("/api/h5/invoice/subjects" + "?phoneNum=" + this.orderPhoneNum + "&orderType=" + this.orderType + "&projectId=" + projectId
      ).then(res => {
        console.log(res);
        this.subjects = res.data.map(dto => ({
          value: dto.id,
          text: dto.billingAccountName,
        }));
        this.subjectId = this.currentSubject?.id;
      })
    },
  },
}
</script>

<style scoped>
.vg-picker {
  height: 100%;
}

.vg-picker-input {

}

.filter {
  position: absolute;
  right: 15px;
  top: 20px;
}

.vg-picker-popup {
  height: 100%;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.month {
  height: 32px;
  margin-top: 10px;
  padding: 0 10px;
  border-radius: 3px;
  border: 1px solid #BBBBBB;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.monthselected {
  border: 1px solid #0052D9;
}

.input {
  margin-right: 15px;
  border: none;
  color: #101010;
  font-size: 14px;
  flex-grow: 1;
}

.project {
  height: 32px;
  margin-top: 10px;
  padding: 0 10px;
  border-radius: 3px;
  border: 1px solid #BBBBBB;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.btn {
  margin-top: 30px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.button-default {
  width: 85px;
  height: 35px;
  border-radius: 10px;
  background-color: #FFFFFF;
  color: #101010;
  font-size: 14px;
  text-align: center;
  border: 1px solid #BBBBBB;
}

.button-primary {
  width: 85px;
  height: 35px;
  border-radius: 10px;
  background-color: #2897FF;
  color: #FFFFFF;
  font-size: 14px;
  text-align: center;
  border: 1px solid #2897FF;
}

.choose-month {
  margin-right: 20px;
  padding: 10px 0;
  background: #FFFFFF;
  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.11);
  position: absolute;
  top: 160px;
  z-index: 10;
}

.choose-header {
  padding: 10px;
  display: flex;
  align-items: center;
}

.year {
  color: #101010;
  font-size: 16px;
  font-weight: bold;
  flex-grow: 1;
}

.month-item {
  height: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.month-text {
  color: #000000;
  font-size: 14px;
}

.monthtextselected {
  color: #0052D9;
}

.month-point {
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: #0052D9;
  position: absolute;
  bottom: 0px;
}

</style>
